import { useLocalization } from '@ais-ui/locale-management';
import { AccordionContent } from '@ais-ui/ui-core';
import React from 'react';
import { AtoNDefinitionWithDate } from '@ais-ui/api';

interface AtonItemContentProps {
  aton: AtoNDefinitionWithDate;
  children: React.ReactNode;
}

export const AtonItemContent = ({ aton, children }: AtonItemContentProps) => {
  const { messages } = useLocalization();

  return (
    <AccordionContent>
      <div className="space-y-4">
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">{messages.atonItemMmsiLabel}</p>
          <p>{aton.mmsi}</p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">
            {messages.atonItemActiveLabel}
          </p>
          <p>
            {aton.enabled
              ? messages.atonItemActiveTrueValue
              : messages.atonItemActiveFalseValue}
          </p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">
            {messages.atonItemActiveLabel}
          </p>
          <p>{aton.description ? aton.description : 'None or unknown'}</p>
        </div>
        <div className="flex px-4 space-x-2">
          <p className="text-muted-foreground">{messages.atonItemShareLabel}</p>
          <p>{aton.groups?.join(', ') || messages.atonItemShareEmptyValue}</p>
        </div>
        {children}
      </div>
    </AccordionContent>
  );
};
